import React from 'react'
import cx from 'classnames'

import Button from 'components/_new/Button/Button'

import s from './Buttons.scss'
import messages from './messages'


const ProductImageWithName = (props) => {
  const {
    onTryButtonClick, onAllProductsButtonClick, withAddToQueueButton, isAllProductsButtonVisible,
    className: _className,
  } = props

  const tryButtonTitle = withAddToQueueButton ? messages.addToQueue : messages.try
  const className = cx(s.buttons, _className)

  return (
    <div className={className}>
      <Button
        title={tryButtonTitle}
        color="brand"
        fullWidth
        size="md"
        rightIcon="rightArrowSmall"
        onClick={onTryButtonClick}
      />
      {
        isAllProductsButtonVisible && (
          <Button
            title={messages.all}
            color="brandBorder"
            fullWidth
            size="md"
            onClick={onAllProductsButtonClick}
          />
        )
      }
    </div>
  )
}

ProductImageWithName.defaultProps = {
  isAllProductsButtonVisible: false,
}

export default ProductImageWithName
